import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

import { Buffer } from "buffer";

const config = JSON.parse(
  Buffer.from(process.env.REACT_APP_FIREBASE_CONFIG || "", "base64").toString(
    "utf-8"
  )
);
// Initialize Firebase
const app = initializeApp(config);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
